import React, { useContext, useState } from "react";
import AlertDialog from "../Components/AlertDialog";
import AppContext from "../appContext";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import * as api from "../services";

export default function LogoutConfirmationDialog({ open, setOpen }) {
  const {
    app: { sessionId },
  } = useContext(AppContext);
  const { t } = useTranslation();
  const logoutMutation = useMutation(() => api.unlockAll({ sessionId }), {
    onSuccess: () => {
      window.location = `${window.REACT_APP_LOGOUT_ADDRESS}?sessionId=${sessionId}`;
    },
  });

  return (
    <AlertDialog
      open={open}
      setOpen={setOpen}
      confirmFunction={() => logoutMutation.mutate()}
      dialogTitle={t("account.dialogs.logoutToUpdateDashboardDialogTitle")}
      dialogContentText={t("account.dialogs.logoutToUpdateDashboardDialogText")}
      dialogActionCancel={t("common.actions.cancel")}
      dialogActionConfirm={t("navigation.logout")}
    />
  );
}
